var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconPauseAudio = function SvgIconPauseAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.5 -21.5)"
  }, /*#__PURE__*/React.createElement("line", {
    "data-name": "Line 4",
    y2: 12,
    transform: "translate(24.5 22.5)",
    fill: "none",
    stroke: "#0090d7",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    "data-name": "Line 5",
    y2: 12,
    transform: "translate(32.5 22.5)",
    fill: "none",
    stroke: "#0090d7",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEwIDE0Ij4NCiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjUgLTIxLjUpIj4NCiAgICA8bGluZSBkYXRhLW5hbWU9IkxpbmUgNCIgeTI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC41IDIyLjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDkwZDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQogICAgPGxpbmUgZGF0YS1uYW1lPSJMaW5lIDUiIHkyPSIxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIuNSAyMi41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA5MGQ3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIconPauseAudio as ReactComponent };